import type { SubscriptionFailureReasonCode } from "@/domains/subscription/subscription.codes.types";
import type { CallTypeId, EventCategoryId } from "@/types/common/ids";

export interface SubscriberDetailsModel {
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  hasDeliveryPoint: boolean;
  isLastSignatureBasic?: boolean;
}

export interface VoltacallTransferSignatureRequestPayload {
  upgradeToPremium?: boolean;
  acceptEnergyOffers: boolean;
  acceptPartnerOffers: boolean;
}

export interface TransferSignatureModel {
  signatureUrl: string;
}

interface EndCallCommon {
  comment?: string;
}

export enum EndCallStatus {
  CONFIRM_ELIGIBILITY = "CONFIRM_ELIGIBILITY",
  NO_TECHNICIAN_AVAILABILITY = "NO_TECHNICIAN_AVAILABILITY",
  NO_SUBSCRIBER_AVAILABILITY = "NO_SUBSCRIBER_AVAILABILITY",
  SUBSCRIPTION_FAILURE = "SUBSCRIPTION_FAILURE",
  UNREACHABLE = "UNREACHABLE",
  SIMPLE_CONSULTATION = "SIMPLE_CONSULTATION",
}

export interface EndCallConfirmEligibilityPayload extends EndCallCommon {
  status: EndCallStatus.CONFIRM_ELIGIBILITY;
  callTypeId: CallTypeId;
  closeEventCategoryIdOverride?: EventCategoryId;
}

export interface EndCallNoTechnicianAvailabilityPayload extends EndCallCommon {
  status: EndCallStatus.NO_TECHNICIAN_AVAILABILITY;
  callTypeId: CallTypeId;
  closeEventCategoryIdOverride?: EventCategoryId;
}

export interface EndCallNoSubscriberAvailabilityPayload extends EndCallCommon {
  status: EndCallStatus.NO_SUBSCRIBER_AVAILABILITY;
  callTypeId: CallTypeId;
  closeEventCategoryIdOverride?: EventCategoryId;
}

export interface EndCallEligibilityKoPayload extends EndCallCommon {
  status: EndCallStatus.SUBSCRIPTION_FAILURE | EndCallStatus.UNREACHABLE;
  callTypeId: CallTypeId;
  reason: SubscriptionFailureReasonCode;
}

export interface EndCallSimpleConsultationPayload extends EndCallCommon {
  status: EndCallStatus.SIMPLE_CONSULTATION;
}

export type EndCallRequestPayload =
  | EndCallConfirmEligibilityPayload
  | EndCallNoTechnicianAvailabilityPayload
  | EndCallNoSubscriberAvailabilityPayload
  | EndCallEligibilityKoPayload
  | EndCallSimpleConsultationPayload;

type StatusOfMembersWithKey<T extends { status: PropertyKey }, K extends string> = T extends unknown
  ? K extends keyof T
    ? T["status"]
    : never
  : never;

/**
 * Statuses that allow close event override
 */
export type CloseEventOverrideStatuses = StatusOfMembersWithKey<EndCallRequestPayload, "closeEventCategoryIdOverride">;
